import servise from '@/router/axios'

export const addProfitAteApp = (data) => {
    return servise({
        url: '/webReportKeyword/add/profit/ate',
        method: 'post',
        data
    })
}

export const webReportKeyword = (params) => {
    return servise({
        url:'/webReportKeyword/app/list',
        method:'get',
        params
    })
}